import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ScrollAnchorService } from './scroll-anchor.service';
import { Subject, switchMap, takeUntil, tap } from 'rxjs';
import { IntersectionObservableService } from '../intersection-observable/intersection-observable.service';

@Directive({
  selector: '[prlwScrollAnchor]',
  standalone: true,
})
export class ScrollAnchorDirective implements OnInit, OnDestroy {
  @Input() prlwScrollAnchor: string = 'foo';

  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private readonly scrollAnchorService: ScrollAnchorService,
    private readonly el: ElementRef,
    private readonly intersectionObservableService: IntersectionObservableService,
  ) {}

  ngOnInit(): void {
    this.scrollAnchorService.addElement(this.prlwScrollAnchor, this.el);

    this.scrollAnchorService.targetElement$
      .pipe(
        switchMap((root) => {
          const { height: rootHeight } = root.getBoundingClientRect();
          return this.intersectionObservableService
            .createIntersectionObservable(this.el.nativeElement, {
              root,
              rootMargin: `-${rootHeight / 3}px 0px -${
                rootHeight - rootHeight / 3 - 20
              }px 0px`,
              threshold: [0],
            })
            .pipe(
              tap((entries) => {
                if (entries?.[0]?.isIntersecting) {
                  this.scrollAnchorService.setIntersectionAnchor(
                    this.prlwScrollAnchor,
                  );
                }
              }),
            );
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
